module.exports = __webpack_public_path__ + "img/cash_white.a0d4fc96.svg";